/**
 * Free Shipping Announcement Updater
 */

(function () {
  const freeShippingEl = document.querySelector("free-shipping.free-shipping");
  if (!freeShippingEl) return;

  const remainingTextDiv = freeShippingEl.querySelector(
    ".free-shipping--text-remaining",
  );
  const fullTextDiv = freeShippingEl.querySelector(".free-shipping--text-full");
  const minimum = parseInt(freeShippingEl.dataset.minimum, 10);
  let lastTotal = parseInt(freeShippingEl.dataset.cartTotal, 10);

  function updateAnnouncement(newTotal) {
    const percentage = newTotal < minimum ? newTotal / minimum : 1;

    if (newTotal < minimum) {
      const remaining = minimum - newTotal;
      const format =
        window.theme.settings.money_with_currency_format || "${{amount}}";
      const formattedAmount = formatMoney(remaining, format);

      const amountSpan = remainingTextDiv.querySelector("span");
      if (amountSpan) {
        amountSpan.innerHTML = formattedAmount;
      }

      remainingTextDiv.style.display = "block";
      fullTextDiv.style.display = "none";
    } else {
      remainingTextDiv.style.display = "none";
      fullTextDiv.style.display = "block";
    }

    freeShippingEl.style.setProperty("--percentage", percentage);
  }

  // Poll for cart changes
  setInterval(function () {
    fetch(`${theme.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((data) => {
        const currentTotal = data.total_price;
        if (currentTotal !== lastTotal) {
          lastTotal = currentTotal;
          updateAnnouncement(currentTotal);
        }
      });
  }, 500);
})();
